import { computed } from '@ember/object';
import getWithZeroDefault from '@intercom/pulse/lib/get-with-zero-default';

export default function addTo(dependentKey, delta) {
  return computed(dependentKey, function () {
    return getWithZeroDefault(this, dependentKey) + delta;
  });
}
